import { GetByIdResource, createApiResource } from '../apiResourceFactory';
import { PoolBrainAPI } from '../apiService';
import { PoolBrainCustomerDetailDTO } from '../apiTypes.shim';

export type PoolBrainCustomerResource = GetByIdResource<PoolBrainCustomerDetailDTO>;

export const createPoolBrainCustomerResource = (companyId: string): PoolBrainCustomerResource => {
  const customerResourceUri = `${companyId}/customers`;

  const { useGetById, getById, getByIdQueryKey } = createApiResource(PoolBrainAPI, customerResourceUri);
  return {
    useGetById,
    getById,
    getByIdQueryKey
  };
};
